import { Tooltip } from "@similarweb/ui-components";
import { Box, Flex } from "@similarweb/ui-components/foundations";

import { translate } from "app/filters/i18nFilter";
import signalEventsService from "app/pages/sales-intelligence/modules/company-analysis/services/signals/signalEventsService";
import type { EcommerceSignalEventDto } from "app/pages/sales-intelligence/modules/company-analysis/types/signals";

import { StyledSignalBoxTag } from "../SignalEventBoxItem/styles";

type EcommerceSignalEventInfoBoxProps = {
    signal: EcommerceSignalEventDto;
    "data-automation"?: string;
};

const getEcommerceEventTagTooltip = (tag: string): string => {
    const key = `si.signals.ecommerce.event-tag.${tag.toLowerCase()}.tooltip`;
    const translated = translate(key);
    return translated === key ? tag : translated;
};

const EcommerceSignalEventInfoBox = ({
    signal,
    "data-automation": dataAutomation,
}: EcommerceSignalEventInfoBoxProps) => {
    const tags = signalEventsService.getSignalEventTags(signal);

    if (tags.length === 0) {
        return null;
    }

    return (
        <Box data-automation={dataAutomation}>
            <Flex
                flexWrap="wrap"
                gap="4px"
            >
                {tags.map((tag) => (
                    <Tooltip
                        key={tag}
                        content={getEcommerceEventTagTooltip(tag)}
                        placement="top"
                    >
                        <StyledSignalBoxTag data-automation={`signal-ecommerce-tag-${tag.toLowerCase()}`}>
                            {tag}
                        </StyledSignalBoxTag>
                    </Tooltip>
                ))}
            </Flex>
        </Box>
    );
};

export default EcommerceSignalEventInfoBox;
